'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Immutable = require('Immutable');

var _colors = require('MeetingsBase/constants/colors');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  primaryColor: _colors.DEFAULT_COLOR,
  logoUrl: null
};

var Branding = function (_Record) {
  _inherits(Branding, _Record);

  function Branding() {
    _classCallCheck(this, Branding);

    return _possibleConstructorReturn(this, (Branding.__proto__ || Object.getPrototypeOf(Branding)).apply(this, arguments));
  }

  _createClass(Branding, null, [{
    key: 'from',
    value: function from(json) {
      if (json) {
        var logoUrl = json.hasOwnProperty('logoUrl') ? json.logoUrl : json.companyLogo;
        var primaryColor = json.hasOwnProperty('primaryColor') ? json.primaryColor : json.accentColor;
        return new Branding({
          primaryColor: primaryColor || _colors.DEFAULT_COLOR,
          logoUrl: logoUrl
        });
      }
      return new Branding();
    }
  }]);

  return Branding;
}((0, _Immutable.Record)(defaults));

exports.default = Branding;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/models/Branding.js
// module id = 10
// module chunks = 0